import {
  V2Dialog,
  V2DialogContent,
  V2DialogHeader,
  V2Radio,
  V2RadioGroup,
} from "@stacklet/ui";

interface Props {
  openDialog(arg: boolean): void;
  isDialogOpen: boolean;
  onViewChanged(arg: string): void;
  children: React.ReactNode;
  selectedValue: string;
  radioOptions: { title: string; value: string }[];
  type: string;
}

export function DialogWithRadioOptions({
  children,
  openDialog,
  isDialogOpen,
  radioOptions,
  onViewChanged,
  selectedValue,
  type,
}: Props) {
  const selectedTitle =
    radioOptions.find((option) => option.value === selectedValue)?.title ?? "";

  return (
    <V2Dialog
      data-testid={`form-dialog-${type}-${selectedValue}`}
      isOpen={isDialogOpen}
      onOpenChange={(open) => !open && openDialog(false)}
      size="xl"
      isDismissable
    >
      <V2DialogHeader>{selectedTitle}</V2DialogHeader>
      <V2DialogContent>
        <V2RadioGroup
          aria-label="view-dialog"
          className="pb-lg"
          name="viewDialog"
          onChange={onViewChanged}
          orientation="horizontal"
          value={selectedValue}
        >
          {radioOptions.map((option) => (
            <V2Radio key={option.value} value={option.value}>
              {option.title}
            </V2Radio>
          ))}
        </V2RadioGroup>
        {children}
      </V2DialogContent>
    </V2Dialog>
  );
}
